export default __webpack_public_path__ + "static/media/inventoryIcon.6699a090.svg";